import React, { useEffect, useState } from "react";
import AdminLayout from "../../Layout";
import {
  IoMdAdd,
  IoMdArrowRoundBack,
  IoMdTrash,
  IoMdCreate,
} from "react-icons/io";
import { Button, Modal, TextInput, Spinner, Alert } from "flowbite-react";
import Select from "react-select";
import {
  useCreateFolderMutation,
  useUpdateFolderMutation,
  useDeleteFolderMutation,
  useGetAllAssignmentsQuery,
  useGetAllFoldersQuery,
} from "../../../../graphql/generated.tsx";
import ConformationModal from "../../Components/ConformationModal";
import { Link } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import Loader from "../../../../components/Loader.jsx";

function getFolderMetrics(folder) {
  const ids = folder?.assignments ?? [];
  return { assignmentCount: ids.length };
}

const FolderListing = () => {
  const [isCreateModalOpen, setIsCreateModalOpen] = useState(false);
  const [isEditModalOpen, setIsEditModalOpen] = useState(false);
  const [folderName, setFolderName] = useState("");
  const [selectedAssignments, setSelectedAssignments] = useState([]);
  const [errorMessage, setErrorMessage] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [currentFolderId, setCurrentFolderId] = useState(null);
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
  const [folderToDelete, setFolderToDelete] = useState(null);
  const [Isload, setIsload] = useState(true);
  const navigate = useNavigate();

  const { data: assignmentsData, refetch: assignmentrefetch,  loading: isAssignmentLoading } =
    useGetAllAssignmentsQuery();
  const { data: foldersData, refetch, loading: isFolderloading } = useGetAllFoldersQuery();

  useEffect(() => {
    refetch();
    assignmentrefetch();
  }, [assignmentsData]);

  const assignments = assignmentsData?.getAllAssignments;
  const folders = foldersData?.getAllFolders;

  const existingFolderNames = folders?.map((folder) =>
    folder.name.toLowerCase()
  );

  //loading
   useEffect(()=>{
    setTimeout(()=>{
      setIsload(false);
    },2000);
  },[]);

  const toggleCreateModal = () => {
    setErrorMessage("");
    setIsCreateModalOpen(!isCreateModalOpen);
    if (isCreateModalOpen) {
      // Clear form if closing the modal
      setFolderName("");
      setSelectedAssignments([]);
    }
  };

  const toggleEditModal = () => {
    setErrorMessage("");
    setIsEditModalOpen(!isEditModalOpen);
    if (isEditModalOpen) {
      // Clear form if closing the modal
      setFolderName("");
      setSelectedAssignments([]);
      setCurrentFolderId(null);
    }
  };

  const handleAssignmentChange = (selectedOptions) => {
    setSelectedAssignments(selectedOptions.map((option) => option.value));
  };

  const [createFolder] = useCreateFolderMutation();
  const [updateFolder] = useUpdateFolderMutation();
  const [deleteFolder] = useDeleteFolderMutation();

  const handleFolderCreate = async () => {
    if (!folderName.trim()) {
      setErrorMessage("Assignment category name is required.");
      return;
    }



  
    if (
      existingFolderNames &&
      existingFolderNames.includes(folderName.trim().toLowerCase())
    ) {
      setErrorMessage(
        `An assignment category with the name "${folderName}" already exists.`
      );
      return;
    }

    if (selectedAssignments.length === 0) {
      setErrorMessage("Please select at least one assignment.");
      return;
    }

    setErrorMessage("");
    setIsLoading(true);

    try {
      await createFolder({
        variables: {
          createFolderDto: {
            name: folderName,
            assignments: selectedAssignments,
          },
        },
      });
      refetch();
      toggleCreateModal(); // Close modal on success
    } catch (error) {
      setErrorMessage(
        "An error occurred while creating the assignment category. Please try again."
      );
    } finally {
      setIsLoading(false);
    }
  };

  const handleFolderUpdate = async () => {
    if (!folderName.trim()) {
      setErrorMessage("Assignment category name is required.");
      return;
    }

    setErrorMessage("");
    setIsLoading(true);

    try {
      await updateFolder({
        variables: {
          id: currentFolderId,
          updateFolderDto: {
            name: folderName,
            assignments: selectedAssignments,
          },
        },
      });
      refetch();
      toggleEditModal();
    } catch (error) {
      setErrorMessage(
        "An error occurred while updating the assignment category. Please try again."
      );
    } finally {
      setIsLoading(false);
    }
  };

  const confirmDeleteFolder = async () => {
    try {
      await deleteFolder({ variables: { id: folderToDelete } });
      refetch();
      setFolderToDelete(null);
    } catch (error) {
      setErrorMessage(
        "An error occurred while deleting the assignment category."
      );
    }
  };
  const handleDeleteConfirmation = (folderId) => {
    setFolderToDelete(folderId);
    setIsDeleteModalOpen(true);
  };

   if (isAssignmentLoading || isFolderloading || Isload) {
     return (
       <AdminLayout>
         <div className="flex items-center justify-center h-screen">
           <Loader />
         </div>
       </AdminLayout>
     );
   }
  return (
    <AdminLayout>
      <ConformationModal
        openModal={isDeleteModalOpen}
        setOpenModal={setIsDeleteModalOpen}
        event={confirmDeleteFolder}
        text="Are you sure you want to delete this assignment category?"
      />
      <div className="min-h-screen p-8 bg-white">
        <div className="flex items-center justify-between mb-8 max-md:gap-2">
          <div className="flex items-center">
            <button
              onClick={() => window.history.back()}
              className="text-gray-500 hover:text-gray-700 focus:outline-none"
            >
              <IoMdArrowRoundBack className="w-6 h-6" />
            </button>
            <div className="ml-2 text-2xl font-bold max-md:text-lg">
              Assignment Category
            </div>
          </div>
          <div className="flex gap-5">
            <Button className="p-0 bg-primary">
              <Link to="/admin/reports/report-message" className="flex">
                <IoMdAdd className="mt-1 mr-1" /> <span>Scorecard Message</span>
              </Link>
            </Button>
            <Button onClick={toggleCreateModal} className="p-0 bg-primary">
              <IoMdAdd className="mt-1 mr-1" /> <span>Create Category</span>
            </Button>
            <Button className="p-0 bg-primary">
              <Link to="/admin/assignments/create-assignment" className="flex">
                <IoMdAdd className="mt-1 mr-1" /> <span>Create Assignment</span>
              </Link>
            </Button>
          </div>
        </div>
        <div className="grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-3">
          {folders?.map((folder) => {
            const { assignmentCount } = getFolderMetrics(folder);
            return (
            <div
              key={folder.id}
              className="relative overflow-hidden transition-all duration-200 bg-white border border-gray-100 shadow-sm cursor-pointer rounded-xl hover:shadow-md group"
              onClick={() =>
                navigate(`/admin/assignment-folders/${folder?.id}/assignments`)
              }
            >
              {/* Card Content */}
              <div className="p-5">
                {/* Icon Buttons - Only appear on hover */}
                <div className="absolute flex space-x-1 transition-opacity duration-200 opacity-0 top-3 right-3 group-hover:opacity-100">
                  <button
                    className="p-1.5 text-gray-500 hover:text-blue-600 hover:bg-blue-50 rounded-lg transition-colors"
                    onClick={(e) => {
                      e.stopPropagation();
                      setCurrentFolderId(folder.id);
                      setFolderName(folder.name);
                      setSelectedAssignments(folder.assignments.map((a) => a));
                      toggleEditModal();
                    }}
                    aria-label="Edit category"
                  >
                    <IoMdCreate className="w-5 h-5" />
                  </button>

                  <button
                    className="p-1.5 text-gray-500 hover:text-red-600 hover:bg-red-50 rounded-lg transition-colors"
                    onClick={(e) => {
                      e.stopPropagation();
                      handleDeleteConfirmation(folder.id);
                    }}
                    aria-label="Delete category"
                  >
                    <IoMdTrash className="w-5 h-5" />
                  </button>
                </div>

                {/* Category Info */}
                <div className="pr-6">
                  <h3 className="text-xl font-semibold text-gray-800 truncate">
                    {folder.name}
                  </h3>
                  <p className="mt-3 text-sm text-gray-500 tabular-nums">
                    {assignmentCount}{" "}
                    {assignmentCount === 1 ? "assignment" : "assignments"}
                  </p>
                </div>
              </div>

              <div className="absolute bottom-0 left-0 right-0 h-1 bg-gradient-to-r from-primary to-indigo-100" />
            </div>
            );
          })}
        </div>

        {/* Create Category Modal */}
        <Modal show={isCreateModalOpen} onClose={toggleCreateModal}>
          <Modal.Header>Add New Category</Modal.Header>
          <Modal.Body>
            <div className="space-y-4">
              {errorMessage && <Alert color="failure">{errorMessage}</Alert>}
              <TextInput
                id="folderName"
                placeholder="Enter category name"
                value={folderName}
                onChange={(e) => {
                  setErrorMessage("");
                  setFolderName(e.target.value);
                }}
                required
                className="mb-2"
              />
              <div className="h-[200px]">
                <Select
                  isMulti
                  name="assignments"
                  options={assignments?.map((assign) => ({
                    value: assign.id,
                    label: assign.name,
                  }))}
                  className="basic-multi-select"
                  classNamePrefix="select"
                  onChange={handleAssignmentChange}
                  placeholder="Select assignments"
                />
              </div>
            </div>
          </Modal.Body>
          <Modal.Footer>
            <Button
              className="p-0 bg-primary"
              onClick={handleFolderCreate}
              disabled={isLoading}
            >
              {isLoading ? <Spinner size="sm" /> : "Create"}
            </Button>
            <Button color="gray" className="p-0" onClick={toggleCreateModal}>
              Cancel
            </Button>
          </Modal.Footer>
        </Modal>

        {/* Edit Category Modal */}
        <Modal show={isEditModalOpen} onClose={toggleEditModal}>
          <Modal.Header>Edit Category</Modal.Header>
          <Modal.Body>
            <div className="space-y-4">
              {errorMessage && <Alert color="failure">{errorMessage}</Alert>}
              <TextInput
                id="folderName"
                placeholder="Enter category name"
                value={folderName}
                onChange={(e) => {
                  setErrorMessage("");
                  setFolderName(e.target.value);
                }}
                required
                className="mb-2"
              />
              <div className="h-[200px]">
                <Select
                  isMulti
                  name="assignments"
                  options={assignments?.map((assign) => ({
                    value: assign.id,
                    label: assign.name,
                  }))}
                  className="basic-multi-select"
                  classNamePrefix="select"
                  onChange={handleAssignmentChange}
                  placeholder="Select assignments"
                  value={selectedAssignments.map((id) => ({
                    value: id,
                    label: assignments?.find((assign) => assign.id === id)
                      ?.name,
                  }))}
                />
              </div>
            </div>
          </Modal.Body>
          <Modal.Footer>
            <Button
              className="p-0 bg-primary"
              onClick={handleFolderUpdate}
              disabled={isLoading}
            >
              {isLoading ? <Spinner size="sm" /> : "Update"}
            </Button>
            <Button color="gray" className="p-0" onClick={toggleEditModal}>
              Cancel
            </Button>
          </Modal.Footer>
        </Modal>
      </div>
    </AdminLayout>
  );
};

export default FolderListing;